"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameOfGroupOfQueryFormItems = void 0;
var NameOfGroupOfQueryFormItems;
(function (NameOfGroupOfQueryFormItems) {
    NameOfGroupOfQueryFormItems["ShippingMethod"] = "shippingMethod";
    NameOfGroupOfQueryFormItems["PaymentMethod"] = "paymentMethod";
    NameOfGroupOfQueryFormItems["ProductCategory"] = "productCategory";
    NameOfGroupOfQueryFormItems["CurrencyCode"] = "currencyCode";
    NameOfGroupOfQueryFormItems["CustomVariable"] = "customVarName";
    NameOfGroupOfQueryFormItems["TransactionName"] = "affiliation";
})(NameOfGroupOfQueryFormItems = exports.NameOfGroupOfQueryFormItems || (exports.NameOfGroupOfQueryFormItems = {}));
//# sourceMappingURL=types.js.map